<app-slide-in-right-modal
  [modalTitle]="'Create Minor Account'"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [returnPath]="returnPathUrl"
  [slideOpen]="true"
  (action)= "closeModal()"
>
  <div class="page__container flex flex-col pb-8">
    <div class="flex flex-col gap-4 px-0 pt-6">

      <!-- Has NIN Button -->
      <button 
        (click)="navigateToHasNIN()"
        [disabled]="isLoading"
        class="w-full flex items-center justify-between rounded-xl border border-mango-floralWhite bg-white px-5 py-4 transition-all duration-200 hover:bg-mango-floralWhite focus-visible:outline-mango disabled:cursor-not-allowed disabled:opacity-50"
      >
        <div class="flex items-center gap-4">
          <div class="flex h-12 w-12 items-center justify-center rounded-full bg-mango-papayaWhip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
              <path d="M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z" />
            </svg>
          </div>

          <span class="text-sm font-medium text-mango-black17">
            With NIN
          </span>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path d="M9.5 19L15.5 12L9.5 5"
            stroke="#1C274C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>

      <!-- Does Not Have NIN Button -->
      <button 
        (click)="navigateToNoNIN()"
        [disabled]="isLoading"
        class="w-full flex items-center justify-between rounded-xl border border-mango-floralWhite bg-white px-5 py-4 transition-all duration-200 hover:bg-mango-floralWhite focus-visible:outline-mango disabled:cursor-not-allowed disabled:opacity-50"
      >
        <div class="flex items-center gap-4">
          <div class="flex h-12 w-12 items-center justify-center rounded-full bg-mango-papayaWhip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
              <path d="M10.375 2.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25ZM10.375 12a7.125 7.125 0 0 0-7.124 7.247.75.75 0 0 0 .363.63 13.067 13.067 0 0 0 6.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 0 0 .364-.63l.001-.12v-.002A7.125 7.125 0 0 0 10.375 12ZM16 9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z" />
            </svg>
          </div>

          <span class="text-sm font-medium text-mango-black17">
            Without NIN
          </span>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path d="M9.5 19L15.5 12L9.5 5"
            stroke="#1C274C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>

    </div>
    <router-outlet></router-outlet>
  </div>
</app-slide-in-right-modal>
